import React from 'react'
import { clsx } from 'clsx'
import { USER_STATUS, USER_ROLE } from '@/shared/api'

export interface StatusBadgeProps {
  status: number
  type: 'status' | 'role'
  variant?: 'dot' | 'filled'
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  status,
  type,
  variant = 'filled',
}) => {
  const getStatusConfig = (status: number, type: 'status' | 'role') => {
    if (type === 'status') {
      switch (status) {
        case USER_STATUS.ACTIVE:
          return { text: 'Активен', color: 'success' }
        case USER_STATUS.BLOCKED:
          return { text: 'Заблокирован', color: 'error' }
        case USER_STATUS.DELETED:
          return { text: 'Удален', color: 'gray' }
        default:
          return { text: 'Неизвестен', color: 'gray' }
      }
    } else {
      switch (status) {
        case USER_ROLE.ADMIN:
          return { text: 'Администратор', color: 'primary' }
        case USER_ROLE.COURIER:
          return { text: 'Курьер', color: 'primary' }
        case USER_ROLE.EXTERNAL_COURIER:
          return { text: 'Сторонний курьер', color: 'warning' }
        case USER_ROLE.DEFAULT_USER:
          return { text: 'Пользователь', color: 'gray' }
        default:
          return { text: 'Неизвестно', color: 'gray' }
      }
    }
  }

  const { text, color } = getStatusConfig(status, type)

  const colorClasses = {
    primary: variant === 'filled' 
      ? 'bg-primary-100 text-primary-800' 
      : 'text-primary-600 bg-primary-100',
    success: variant === 'filled' 
      ? 'bg-success-100 text-success-800' 
      : 'text-success-600 bg-success-100',
    warning: variant === 'filled' 
      ? 'bg-warning-100 text-warning-800' 
      : 'text-warning-600 bg-warning-100',
    error: variant === 'filled' 
      ? 'bg-error-100 text-error-800' 
      : 'text-error-600 bg-error-100',
    gray: variant === 'filled' 
      ? 'bg-gray-100 text-gray-800' 
      : 'text-gray-600 bg-gray-100',
  }

  return (
    <span
      className={clsx(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium',
        colorClasses[color as keyof typeof colorClasses]
      )}
    >
      {variant === 'dot' && (
        <span
          className={clsx(
            'w-1.5 h-1.5 mr-1.5 rounded-full',
            color === 'primary' && 'bg-primary-600',
            color === 'success' && 'bg-success-500',
            color === 'warning' && 'bg-warning-500',
            color === 'error' && 'bg-error-500',
            color === 'gray' && 'bg-gray-400'
          )}
        />
      )}
      {text}
    </span>
  )
}
